import { Backdrop, Box, Chip, Typography } from '@mui/material';
import styled from 'styled-components';

export const StyledSearchBar = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  margin-bottom: 50px;
  width: 80%;
  margin-left: 10%;
`;

export const StyledChip = styled(Chip)`
  cursor: pointer;
`;
export const StyledBox = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 10px;
  overflow-x: auto;
  scroll-behavior: smooth;
  white-space: nowrap;
  padding: 10px;
  max-width: 100%;
  box-sizing: border-box;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const StyledBoxNotScrollable = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 5px;
  flex-wrap: wrap;
  padding: 5px;
  max-width: 100%;
  box-sizing: border-box;
`;

export const StyledTypo = styled(Typography)`
  display: flex;
  align-items: center;
  margin-top: 10px;
`;
export const StyledTypo2 = styled(Typography)`
  display: flex;
  align-items: center;
`;
export const StyledBackdrop = styled(Backdrop)`
  color: #fff;
  z-index: 1000000;
`;
export const STyledOptionsFilterBox = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40%;
  height: 40%;
  padding: 16px;
  border-radius: 8px;
  background-color: #3c3c5c;
`;
export const StyledTypo3 = styled(Typography)`
  margin-top: 8px;
`;
